import React from 'react';
import {Input} from '../../input/input';
import FontBody2 from '../../../fonts/font-body2/font-body2';
import IconDropDownMediumArrow from '../../../icons/icon-drop-down-medium-arrow/icon-drop-down-medium-arrow';
import './input-with-overlay.scss';
import {ICON_SIZE} from "../../../icons/icon-props-interface";
import {FONT_COLOR} from "../../../fonts/font-props";

export interface InputWithOverlayProps {
    value: string;
    onChange: (value: string) => void;
    summaryText?: string;
    placeholder?: string;
    onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
    setReferenceNode?: (node: HTMLDivElement | null) => void;
    isInputDisabled?: boolean
}

const InputWithOverlay: React.FC<InputWithOverlayProps> = (
    {
        value,
        onChange,
        summaryText,
        placeholder,
        onMouseDown,
        setReferenceNode,
        isInputDisabled = false
    }
) => {

    return (
        <div ref={setReferenceNode} onMouseDown={onMouseDown} className={`input-with-overlay__wrapper ${isInputDisabled ? 'disabled' : ''}`}>
            <Input
                value={value}
                onChange={onChange}
                placeholder={''}
                button={{iconComp: () => <div style={{opacity: isInputDisabled ? 0.5 : 1}}><IconDropDownMediumArrow size={ICON_SIZE.MEDIUM}/></div>}}
                disabled={isInputDisabled}
            />
            {value === '' && (
                <div className="input-with-overlay__overlay">
                    <div className="input-with-overlay__overlay-text">
                        <FontBody2 color={isInputDisabled ? FONT_COLOR.PRIMARY3_50 : FONT_COLOR.PRIMARY3}>{summaryText || placeholder || ''}</FontBody2>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InputWithOverlay;


